import React from "react";
import { Carousel } from "react-responsive-carousel";

const Renders = ({ data }) => {
  if (data) {
    var renders = data.renders.map(function (render, i) {
      var projectImage = "images/carousel/" + render.url;
      return (
        <div key={i}>
          <img src={projectImage} alt={render.descript}></img>
        </div>
      );
    });
  }

  return (
    <section id="renders">
      <Carousel
        className="carousel-container"
        autoPlay
        infiniteLoop
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
        interval={3000}
      >
        {renders}
      </Carousel>
    </section>
  );
};

export default Renders;
